import './Button.scss';
import cn from "classnames";

const Button = ({ children, color, onClick, style }) => {
  return (
    <button
      className={cn('Button', color)}
      style={style}
      onClick={onClick}
    >
      { children }
    </button>
  );
}

export default Button;